var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("H3TitleView", { staticClass: "title mb-4 ml-1 small-title" }, [
        _vm._v(" " + _vm._s(_vm.title))
      ]),
      _vm.actualites.length === 0
        ? _c("b-message", { attrs: { type: "is-waring" } }, [
            _vm._v(" " + _vm._s(_vm.$t("actualitesPage.no-actu")) + " ")
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "actualites-card-content" },
        [
          _vm.isLoadingData
            ? _c("LoadingSkeleton", {
                attrs: { "loading-text": _vm.$t("actualitesPage.loading") }
              })
            : _vm._l(_vm.actualites, function(actualite, i) {
                return _c("ActualiteCard", {
                  key: i,
                  class: { "mt-3": i > 0 },
                  attrs: { actualite: actualite },
                  on: { "read-more": _vm.openModale }
                })
              })
        ],
        2
      ),
      _c(
        "b-modal",
        {
          staticClass: "actualitesCardsView-modale",
          attrs: {
            active: _vm.open,
            "has-modal-card": "",
            "trap-focus": "",
            "aria-role": "dialog",
            "aria-label": "actualitesCardsView",
            "aria-modal": "",
            width: "100vw"
          },
          on: {
            cancel: function($event) {
              _vm.open = false
            }
          }
        },
        [
          [
            _c("div", { staticClass: "modal-card" }, [
              _c(
                "header",
                { staticClass: "modal-card-head" },
                [
                  _vm.actualiteSelected.grae
                    ? _c("H3TitleView", { staticClass: "modal-card-title" }, [
                        _vm._v(
                          _vm._s(_vm.$t("projet.en-bref.actu-regionale")) + " "
                        )
                      ])
                    : _c("H3TitleView", { staticClass: "modal-card-title" }, [
                        _vm._v(
                          _vm._s(_vm.$t("projet.en-bref.actu-nationale")) + " "
                        )
                      ]),
                  _c("div", { staticClass: "ActualitesModalView-infos" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("projet.en-bref.postee-le", [
                            _vm.formatDate(
                              _vm.actualiteSelected.dateDebutPublication
                            )
                          ])
                        ) +
                        " "
                    )
                  ])
                ],
                1
              ),
              _c(
                "section",
                { staticClass: "modal-card-body" },
                [
                  _c("H3TitleView", [
                    _vm._v(_vm._s(_vm.actualiteSelected.titre))
                  ]),
                  _c("hr"),
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.actualiteSelected.contenu
                          ? _vm.actualiteSelected.contenu.replaceAll(
                              "\n",
                              "<br/>"
                            )
                          : ""
                      )
                    }
                  })
                ],
                1
              ),
              _c("footer", { staticClass: "modal-card-foot" }, [
                _c("div", { staticClass: "buttons" }, [
                  _c(
                    "div",
                    {
                      staticClass: "hoverable-discrete-link mr-3",
                      on: {
                        click: function($event) {
                          _vm.open = false
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("close-generic")) + " ")]
                  )
                ])
              ])
            ])
          ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }